import React from 'react';
import { Editor } from "slate";
import { EditorPlugin } from "../../slate/PowerEditorConfig";
import { CustomElement } from "../../../../../slate";
import { LabelOutlined } from "@mui/icons-material";
import { FootnoteElement } from './FootnoteElement';
import { EditFootnoteCommand } from './types';
import { FootnoteEditDialog } from './FootnoteEditDialog';
import { useFootnoteEdit } from './useFootnotesEdit';
import { generateCode } from '../common';



export const FootnoteElementType = "footnote";

export const withFootnotes = (editor: Editor) => {
  const { isInline, isVoid } = editor
  
  editor.isInline = (element: CustomElement) => {
    return element.type === FootnoteElementType ? true : isInline(element)
  }
  
  editor.isVoid = (element: CustomElement) => {
    return element.type === FootnoteElementType ? true : isVoid(element)
  }
  
  return editor
}

export const useFootnotesEditorPlugin = (): EditorPlugin => {
  const editing = useFootnoteEdit();

  return {
    key: "footnotes",
    inject: e => withFootnotes(e),
    customBlocks: { [FootnoteElementType]: FootnoteElement },
    dialogs: editing.editingContext
      ? <>
        <FootnoteEditDialog
          data={editing}
          />
        </>
      : undefined,
    commands: [{
      name: "insert-footnote",
      invoke: editor => {
        editor.insertNode({
          type: FootnoteElementType,
          _id: `ftn_${generateCode()}_${generateCode()}`,
          children: [{ text: "", }],
        } as any);
      },
      menu: { label: "Footnote", label_id: "powerdoc.plugins.footnote.title", section: "insert-item", icon: <LabelOutlined /> },
    },
    {
      name: EditFootnoteCommand,
      isInternal: true,
      invoke: (editor,element) => {
        if(element && element.type === FootnoteElementType) {
          editing.startEditing(editor, element);
        }
      },
    }],
    }
}
